import {
   PreInterviewConfiguration,
   PreInterviewNotificationChannel,
} from '@dreryk/egabinet-patient-portal-frontend-api';

import { NotificationChannel } from './fields/NotificationChannelField.types';
import { PreInterviewSettingsFormBean } from './PreInterviewSettingsForm.types';

const DEFAULT_PRE_INTERVIEW_SETTINGS: PreInterviewSettingsFormBean = {
   preInterviewEnabled: true,
   preInterviewNotificationChannel: 'SMS_AND_EMAIL',
   preInterviewSendingMode: 'ON_APPOINTMENT_CREATED',
};

const channelsMap: Record<NotificationChannel, PreInterviewNotificationChannel[]> = {
   SMS_AND_EMAIL: ['SMS', 'EMAIL'],
   SMS: ['SMS'],
   EMAIL: ['EMAIL'],
};

const toNotificationChannel = (channels: PreInterviewNotificationChannel[]): NotificationChannel => {
   const sms = channels.includes('SMS');
   const email = channels.includes('EMAIL');
   if (sms && email) {
      return 'SMS_AND_EMAIL';
   }
   if (sms) {
      return 'SMS';
   }
   if (email) {
      return 'EMAIL';
   }
   return DEFAULT_PRE_INTERVIEW_SETTINGS.preInterviewNotificationChannel;
};

export const preInterviewConfigurationToFormBean = (
   configuration: PreInterviewConfiguration | undefined
): PreInterviewSettingsFormBean => {
   if (!configuration) {
      return DEFAULT_PRE_INTERVIEW_SETTINGS;
   }
   return {
      preInterviewEnabled: configuration.enabled,
      preInterviewNotificationChannel: toNotificationChannel(configuration.channels),
      preInterviewSendingMode: configuration.sendingMode,
   };
};

export const formBeanToPreInterviewConfiguration = (bean: PreInterviewSettingsFormBean): PreInterviewConfiguration => {
   return {
      enabled: bean.preInterviewEnabled,
      channels: channelsMap[bean.preInterviewNotificationChannel],
      sendingMode: bean.preInterviewSendingMode,
   };
};
